import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Contacts from './views/Contacts.vue';
import Studio from './views/Studio.vue';
import Services from './views/Services.vue';
import Projects from './views/Projects.vue';
import Project from './views/Project.vue';
import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang(it|en)',
      name: 'home',
      component: Home,
    },
    {
      path: '/',
      redirect: '/en',
    },
    {
      path: '/:lang(en)/contacts',
      name: 'contacts',
      component: Contacts,
    },
    {
      path: '/:lang(it)/contatti',
      name: 'contatti',
      component: Contacts,
    },
    {
      path: '/:lang(it|en)/studio',
      name: 'studio',
      component: Studio,
    },
    {
      path: '/:lang(en)/services',
      name: 'services',
      component: Services,
    },
    {
      path: '/:lang(it)/servizi',
      name: 'servizi',
      component: Services,
    },
    {
      path: '/:lang(en)/projects',
      name: 'projects',
      component: Projects,
    },
    {
      path: '/:lang(it)/progetti',
      name: 'progetti',
      component: Projects,
    },
    {
      path: '/:lang(en)/projects/:project',
      name: 'project',
      component: Project,
    },
    {
      path: '/:lang(it)/progetti/:project',
      name: 'progetto',
      component: Project,
    },
  ],
});

router.beforeEach((to, from, next) => {
  console.log('store.state.lang: ', store.state.lang);
  console.log('to.params.lang: ', to);
  if (store.state.lang !== to.params.lang) {
    store.commit('SET_LANG', to.params.lang);
  }

  if (store.state.menuOpen) store.state.menuOpen = false;

  document.body.classList.add('loading');
  store.dispatch('LOAD_DATA').then(() => {
    document.body.classList.remove('loading');
    next();
  });
});

export default router;
